import React from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth"

const LogoutPage = () => {

    const { setAuth } = useAuth()
    const navigate = useNavigate();

    React.useEffect(() => {
        localStorage.removeItem('token');
        setAuth(false)
        navigate('/auth/login');
    }, [setAuth, navigate])

    return <></>
}

export default LogoutPage;
